import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { EnumBlogStatus } from 'tdc-web-backend/enums/enums';
import AddIcon from '@mui/icons-material/Add';
import useTable from '../../../components/table/useTable';
import CustomButton from '../../../components/button/CustomButton';
import TableWithChipFilters from '../../../components/table/TableWithChipFilters';
import { formatDateFns } from '../../../utils/helpers';
import StatusChipField from '../../../components/StatusChipField/StatusChipField';

const BlogList = () => {
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: 'headline',
      headerName: 'title',
      editable: false,
      flex: 0.3,
    },
    {
      field: 'createdBy',
      headerName: 'Created by',
      editable: false,
      flex: 0.3,
      renderCell: (params: GridRenderCellParams) => (
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 600,
          }}
        >
          {`${params.row.createdBy.firstName || ''} ${params.row.createdBy.lastName || ''}`}
        </Typography>
      ),
    },
    {
      field: 'author',
      headerName: 'Author',
      editable: false,
      flex: 0.3,
      renderCell: (params: GridRenderCellParams) => (
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 600,
          }}
        >
          {`${params.row.author?.firstName || ''} ${params.row.author?.lastName || ''}`}
        </Typography>
      ),
    },

    {
      field: 'published',
      headerName: 'published',
      editable: false,
      flex: 0.3,
      renderCell: (params: GridRenderCellParams) => (
        <Typography sx={{ fontSize: '0.875rem' }}>{formatDateFns(params.value, '-')}</Typography>
      ),
    },
    {
      field: 'status',
      headerName: 'Status',
      flex: 0.1,
      renderCell: (params: GridRenderCellParams) => <StatusChipField text={params.value} />,
    },
  ];

  const { resourceLimit, chipFilters, ...props } = useTable({
    resourceUrl: 'blogs',
    withTabs: true,
    chipFilterQueryParams: [
      {
        title: 'All',
      },
      {
        title: 'published',
        search: { status: EnumBlogStatus.Published },
      },
      {
        title: 'draft',
        search: { status: EnumBlogStatus.Draft },
      },
    ],
  });

  return (
    <TableWithChipFilters
      numberOfRowsPerPage={resourceLimit}
      columns={columns}
      onRowClick={(e) => navigate(`./${e.row.id}/view`)}
      withElements={{
        withTitle: 'Blogs',
        withCta: (
          <CustomButton
            startIcon={<AddIcon sx={{ fontSize: '25px !important' }} />}
            onClick={() => navigate('./create')}
          >
            Add new
          </CustomButton>
        ),
      }}
      chipFilters={
        chipFilters as { label: string; isLoading: boolean; count: number | undefined }[]
      }
      sx={{
        '& .MuiDataGrid-cell': {
          overflowX: 'auto',
        },
      }}
      {...props}
    />
  );
};

export default BlogList;
